import { render, staticRenderFns } from "./WalletVerification.vue?vue&type=template&id=20c0a182&"
import script from "./WalletVerification.vue?vue&type=script&lang=js&"
export * from "./WalletVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports